import cn from 'classnames';
import { HTMLAttributes } from 'react';
import { Link } from 'react-router-dom';
import { UiButton } from '@@/ui/components/ui-button';
import { DiContainer } from '@@/di/di-container';
import { AuthService } from '@@/auth/services/auth.service';

import styles from './index.module.sass';

const authService = DiContainer.get(AuthService);

export function AuthorizeRequired(props: IAuthorizeRequiredProps) {
  const { className, ...rest } = props;
  const rootClass = cn(className, styles.root);

  const onLogin = () => authService.loginInSso();

  return (
    <div className={rootClass} {...rest}>
      <div className={styles.title}>Необходимо авторизоваться</div>

      <div className={styles.actions}>
        <UiButton label="Авторизоваться" onClick={onLogin} />
        <Link to="/">
          <UiButton view="clear" label="На главную" />
        </Link>
      </div>
    </div>
  );
}

export interface IAuthorizeRequiredProps extends HTMLAttributes<HTMLDivElement> {}
